import phone from 'phone';
import { PHONE_MASKS, MAP_PHONES } from '@constants/phone';

export const formatPhoneNumber = number => {
    const { isValid, countryIso2, countryCode } = phone(number, { country: null, validateMobilePrefix: false });
    if (!isValid) return number;
    const mask = PHONE_MASKS[countryIso2];

    const numberPart = number.slice(countryCode.length);
    let formattedNumber = '';
    let maskIndex = 0;

    for (let i = 0; i < mask.length; i++) {
        if (mask[i] === '.') {
            formattedNumber += numberPart[maskIndex++] || '';
        } else if (mask[i] === ' ') {
            formattedNumber += mask[i];
        } else if (mask[i] === '(' || mask[i] === ')' || mask[i] === '-') {
            formattedNumber += mask[i];
        }
    }
    return `${countryCode} ${formattedNumber}`;
};

export const setInitialPhoneNumberToForm = (phoneNumber, locale) => {
    const countryCode = MAP_PHONES[locale];
    if (!phoneNumber) return countryCode;
    const formattedNumber = phoneNumber?.startsWith('+') ? phoneNumber?.slice(1) : phoneNumber;
    return formattedNumber || countryCode;
};

export const preparePhoneNumberForSubmit = (phoneNumber, isOptional = false) => {
    if (!isOptional) return `+${phoneNumber}`;
    return phoneNumber.length > 4 ? (phoneNumber?.startsWith('+') ? phoneNumber : `+${phoneNumber}`) : '';
};
